import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type AISeoGenerateRequest as SchemaAISeoGenerateRequest } from '../schemas/AISeoGenerateRequest';
import { type GenerateAISeoShortResponse as SchemaGenerateAISeoShortResponse } from '../schemas/GenerateAISeoShortResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Pages
 */
export const GenerateAISeoForPageContentType = 'application/json' as const;
export type GenerateAISeoForPageRequest = SchemaAISeoGenerateRequest;
export type GenerateAISeoForPageResponses = LinkCommonErrorResponses & {
    /**
     * @description Успешная генерация сео текстов
     */
    '200': {
        'application/json': SchemaGenerateAISeoShortResponse;
    };
};
export type GenerateAISeoForPageResponseSuccess = GenerateAISeoForPageResponses['200']['application/json'];
export type GenerateAISeoForPageSearchParams = undefined;
export type GenerateAISeoForPagePathParameters = {
    page_id: string;
};
export const GenerateAISeoForPageUrl = '/pages/{page_id}/seo/ai/generate' as const;
export const GenerateAISeoForPageMethod = 'POST' as const;
export const getGenerateAISeoForPageUrl = (params: GenerateAISeoForPagePathParameters) =>
    GenerateAISeoForPageUrl.replace(/\{(\w+)\}/g, (_match, param: keyof GenerateAISeoForPagePathParameters) =>
        String(params[param])
    );
